import { VerifyUserPage } from '@/pages/verify-user';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/verify-user')({
  component: VerifyUserPage,
});
